import { signal } from 'services/SignalsService'
import { timings } from 'settings/custom/freespins'
import { delay } from 'utils/Delay'

const name = 'FS-START'

async function execute() {
  if(timings.choise){
    await signal.promise('BUTTON:startFreespin')
      .then(() => signal.dispatch('CHOISE-START'))
    await signal.promise('CHOICE-READY')
    return delay(timings.choise)
  }
  else {
    return signal.promise('BUTTON:startFreespin')
  }
}

export function getFreespinsStartAction() {
  return {
    name,
    execute,
  }
}
